var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterPrivacyOneToOne(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 6.44444C8.54635 6.44444 9.79995 5.22566 9.79995 3.72222C9.79995 2.21878 8.54635 1 6.99995 1C5.45355 1 4.19995 2.21878 4.19995 3.72222C4.19995 5.22566 5.45355 6.44444 6.99995 6.44444Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4431 1.38889C13.2562 1.86524 13.8001 2.73199 13.8001 3.72222C13.8001 4.71244 13.2562 5.5792 12.4431 6.05555",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5333V15H13V14.5333C13 12.7909 13 11.9197 12.6512 11.2542C12.3444 10.6688 11.8549 10.1929 11.2528 9.89458C10.5682 9.55551 9.67216 9.55551 7.88 9.55551H6.12C4.32784 9.55551 3.43176 9.55551 2.74723 9.89458C2.14511 10.1929 1.65557 10.6688 1.34878 11.2542C1 11.9197 1 12.7909 1 14.5333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 15V14.5333C16.9999 12.7909 16.9999 11.9198 16.6512 11.2543C16.3444 10.6689 15.8548 10.1929 15.2527 9.89462",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPrivacyOneToOne);
export default __webpack_public_path__ + "static/media/filter-privacy-one-to-one.12aa16be5db2974276dc7a2217691e45.svg";
export { ForwardRef as ReactComponent };